module.exports = __webpack_public_path__ + "img/mobile_phone_frame.3078cbe0.png";